export interface GarmentPoint {
  X: number;
  Y: number;
}

export interface GarmentMeasurementPoints {
  Point1: GarmentPoint;
  Point2: GarmentPoint;
}

export interface GarmentMeasurementItem {
  Size: number;
  Points: GarmentMeasurementPoints;
}

export interface GarmentMeasurements {
  Shoulder?: GarmentMeasurementItem;
  Chest?: GarmentMeasurementItem;
  WaistTopGarment?: GarmentMeasurementItem;
  LengthTopGarment?: GarmentMeasurementItem;
  Neckline?: GarmentMeasurementItem;
  [key: string]: GarmentMeasurementItem | undefined;
}

export interface GarmentMetaData {
  Date: string;
  FileNames: string[];
}

export interface GarmentMeasurementData {
  Measurements: GarmentMeasurements;
  MetaData: GarmentMetaData;
}

export interface GarmentMeasurementResponse {
  Status: number;
  Message: string;
  Data: GarmentMeasurementData;
}

export interface ValidGarmentMeasurement {
  key: string;
  value: number;
  label: string;
}

export const garmentMeasurementLabels: Record<string, string> = {
  Shoulder: "Shoulder",
  Chest: "Chest",
  WaistTopGarment: "Waist",
  LengthTopGarment: "Length",
  Neckline: "Neckline",
};
